import type { FeatureFlags } from '@cobliteam/hooks/src/useFeatureFlags';
import type { Permission } from '@cobliteam/permissions';
import type { RouteDef, RuntimeFlags, SidebarDef } from '../../../dashboardDef';
import getPagesFlatted from './getPagesFlatted';
import getRouter from './getRouter';
import getRoutesWithFeatureFlag from './getRoutesWithFeatureFlag';
import getRoutesWithPermission from './getRoutesWithPermission';
import getRoutesWithRedirect from './getRoutesWithRedirect';
import getRoutesWithRuntimeFlag from './getRoutesWithRuntimeFlag';

interface GetSidebarProps {
  dashboardDef: RouteDef[];
  runtimeFlags: RuntimeFlags;
  featureFlags: FeatureFlags;
  isAccessAllowed: (permission: Permission) => boolean;
  language?: string;
}

const getSidebar = ({ dashboardDef, runtimeFlags, featureFlags, isAccessAllowed, language = 'pt-BR' }: GetSidebarProps): SidebarDef => {
  const routerDef = dashboardDef;
  const currentPath = window.location.pathname;

  const routerWithRuntimeFlag = getRoutesWithRuntimeFlag(routerDef, runtimeFlags);
  const routerWithPermission = getRoutesWithPermission(routerWithRuntimeFlag, isAccessAllowed);
  const routerWithFeatureFlag = getRoutesWithFeatureFlag(routerWithPermission, featureFlags);
  const routerWithRedirect = getRoutesWithRedirect(routerWithFeatureFlag);
  const { router, route, primary } = getRouter(routerWithRedirect, currentPath);
  const pagesFlatted = getPagesFlatted(router, undefined, undefined, language);

  const currentPrimary = primary || router[0];
  const currentSecondary = currentPrimary?.routes || undefined;

  const hasSecondary = !!currentSecondary && currentSecondary.length > 0;
  const hasRoute = !!route;

  return {
    router,
    route,
    pagesFlatted,
    primary,
    secondary: currentSecondary,
    hasSecondary,
    hasRoute,
  };
};

export default getSidebar;
